<template>
  <div class="about">
    <div class="left-hand">
      <div class="Pngfute">
        <div class="oimg"></div>
      </div>
      <div class="state">
        <div class="setState">
          当前回路状态:
          <p :class="st">{{ statul }}</p>
        </div>
      </div>
      <div class="bar">
        <div :class="onChan" @click="onPo">分闸</div>
        <div class="popo"></div>
        <div :class="onage" @click="onClo">合闸</div>
      </div>
    </div>
    <!-- <div class="fors" v-if="Isshow>0"> -->
    <div class="fors">
      <div class="middle">
        <div class="table">
          <el-table
            :row-style="{ height: '54px' }"
            :header-cell-style="tableHeaderColor"
            :row-class-name="tableRowClassName"
            :data="data"
            border
            prop="name"
          >
            <el-table-column header-row-class-name="tableHead" prop="name" width="105"></el-table-column>
            <el-table-column prop="amount1" label="A/ab"></el-table-column>
            <el-table-column prop="amount2" label="B/bc"></el-table-column>
            <el-table-column prop="amount3" label="C/ac"></el-table-column>
            <el-table-column prop="amount4" label="总"></el-table-column>
            <el-table-column prop="spanw" label="单位"></el-table-column>
          </el-table>
        </div>
        <div class="trigger">
          <div class="swtrGet" @click="drawer = true" type="primary" style="margin-left: 16px">
            <i class="el-icon-sort"></i> 回路切换
          </div>
          <el-drawer title="回路" :visible.sync="drawer" :with-header="false">
            <ul class="infinite-list" style="overflow: auto">
              <div class="upward" @click="roll(1)">
                <i class="el-icon-arrow-up"></i>
              </div>
              <div ref="nav" v-dragscroll class="vue-drag-scroll-out-wrapper">
                <div class="vue-drag-scroll-wrapper" :style="zoomStye">
                  <li
                    @click="add(item.loopId,item)"
                    v-for="item in bgonClick"
                    class="jadk"
                    :key="item.loopId"
                  >{{ item.loopName }}</li>
                  <li class="nonum">没有更多了</li>
                </div>
              </div>
              <div class="downward" @click="roll(2)">
                <i class="el-icon-arrow-down"></i>
              </div>
            </ul>
          </el-drawer>
        </div>
      </div>
      <div class="dexter">
        <div class="oia">
          <div class="myCharts" ref="echartsDom" width></div>
        </div>
        <div class="oib">
          <div class="myCharts1" ref="echartsDom1"></div>
        </div>
        <div class="opl">
          <ul class="PngUl">
            <li class="pngLi">
              <p class="pink"></p>
              <p>222211111</p>
            </li>
            <li class="pngLi">
              <p class="gruen"></p>
              <p>22222222</p>
            </li>
          </ul>
          <div class="myCharts2" ref="echartsDom2"></div>
        </div>
      </div>
    </div>
    <!-- <div class="mar">
      <div class="tors">
        <img src="../assets/img/not_found_data.png" alt />
        <div class="oP">
          暂无数据，请尝试
          <span class="antfos" @click="forsClick()" style="color:#0D94FF">刷新</span>或选择回路
        </div>
      </div>
    </div>-->
  </div>
</template>
<script>
import chainIndex from "../api/play";

export default {
  name: "about",
  data() {
    return {
      //上拉下滑
      scale: 100,

      // 接口是否有值
      Isshow: 0,
      //回路弹窗状态
      drawer: false,
      //回路颜色
      st: "ored",
      // 回路状态
      statul: "合闸",
      //回路切换
      bgonClick: [
        {
          id: 1,
          name: "回路一",
        },
        {
          id: 2,
          name: "回路二",
        },
        {
          id: 3,
          name: "回路三",
        },
        {
          id: 4,
          name: "回路三",
        },
        {
          id: 5,
          name: "回路三",
        },
        {
          id: 6,
          name: "回路三",
        },
        {
          id: 7,
          name: "回路三",
        },
        {
          id: 8,
          name: "回路三",
        },
        {
          id: 9,
          name: "回路三",
        },
        {
          id: 10,
          name: "回路三",
        },
        {
          id: 11,
          name: "回路三",
        },
        {
          id: 12,
          name: "回路三",
        },
        {
          id: 13,
          name: "回路三",
        },
        {
          id: 14,
          name: "回路三",
        },
        {
          id: 15,
          name: "回路三",
        },
        {
          id: 16,
          name: "回路三",
        },
        {
          id: 17,
          name: "回路三",
        },
        {
          id: 18,
          name: "回路三",
        },
        {
          id: 19,
          name: "回路三",
        },
        {
          id: 22,
          name: "回路三",
        },
        {
          id: 33,
          name: "回路三",
        },
      ],
      //分闸合闸
      onChan: "clo",
      onage: "po",
      dialogVisible: false,
      Onchant: false,
      //echarte图形
      myChart: null,
      myChart1: null,
      myChart2: null,
      data: [
        {
          id: "1",
          name: "任务名称",
          amount4: 10,
          amount1: "234",
          amount2: "3.2",
          amount3: 10,
          spanw: "v",
        },
        {
          id: "2",
          name: "任务名称1",
          amount4: 10,
          amount1: "234",
          amount2: "3.2",
          amount3: 10,
          spanw: "v",
        },
        {
          id: "3",
          name: "任务名称2",
          amount1: "234",
          amount2: "3.2",
          amount4: 10,
          amount3: 1,
          spanw: "v",
        },
        {
          id: "4",
          name: "任务名称",
          amount1: "234",
          amount2: "3.2",
          amount4: 10,
          amount3: 10,
          spanw: "v",
        },
        {
          id: "5",
          name: "任务名称1",
          amount1: "234",
          amount2: "3.2",
          amount4: 10,

          amount3: 10,
          spanw: "v",
        },
        {
          id: "6",
          amount4: 10,
          name: "任务名称2",
          amount1: "234",
          amount2: "3.2",
          amount3: 10,
          spanw: "v",
        },
        {
          id: "7",
          name: "任务名称",
          amount1: "234",
          amount2: "3.2",
          amount3: 10,
          spanw: "v",
          amount4: 10,
        },
        {
          id: "8",
          name: "任务名称1",
          amount1: "234",
          amount2: "3.2",
          amount3: 10,
          spanw: "v",
          amount4: 10,
        },
        {
          id: "9",
          name: "任务名称2",
          amount1: "234",
          amount2: "3.2",
          amount3: 10,
          spanw: "v",
          amount4: 10,
        },
      ],
    };
  },
  computed: {
    zoomStye() {
      //  const INIT_WIDTH = 2208
      const INIT_HEIGHT = 1206;
      //  const width = INIT_WIDTH * (1 + (100 - this.scale)/100)
      const height = INIT_HEIGHT * (1 + (100 - this.scale) / 100);

      return {
        // width: `${width}px`,
        height: `${height}px`,
        transform: `scale(${this.scale / 100})`,
      };
    },
  },
  mounted() {
    //第一图
    this.initEcharts();
    this.initEcharts1();
    this.initEcharts2();
    this.appAll();
  },

  methods: {
    //刷新页面
    forsClick() {
      this.$router.go(0);
    },
    //点击滚动条事件
    roll(index) {
      if (index == 2) {
        //滚动的数值  或者  +- = 值  或者死的数值 就是相应位置
        //还有相应的 scrollTop 方法
        console.log(this.$refs.nav.scrollTop);
        this.$refs.nav.scrollTop += 100;
      } else {
        console.log(this.$refs.nav.scrollTop);
        this.$refs.nav.scrollTop -= 100;
      }
    },
    //所有回路接口
    appAll() {
      chainIndex.analogInterface(2).then((res) => {
        this.Isshow = res.data.data.deviceLoops.length;
        console.log(res.data.data.deviceLoops);
        this.bgonClick = res.data.data.deviceLoops;
      });
    },
    //点击事件
    add(index, item) {
      // console.log(index);
      if (index) {
        this.drawer = false;
        console.log(index, item);
      }
    },
    //确认分闸操作
    onPo() {
      const h = this.$createElement;
      this.dialogVisible = true;
      this.$confirm({}, "操作确认", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        // type: "warning",
        // style:"font-weight: 700",
        message: h("p", null, [
          h("span", { style: " font-size:18px" }, "你即将进行"),
          h("b", { style: "color: teal; font-size:18px" }, "分闸"),
          h("span", { style: " font-size:18px" }, "操作 !"),
        ]),
      })
        .then(() => {
          if (this.dialogVisible) {
            this.onChan = "po";
            this.onage = "clo";
            this.statul = "分闸";
            this.st = "ogreen";
          }
          this.$message({
            type: "success",
            message: "分闸操作成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    //确认合闸操作
    onClo() {
      const h = this.$createElement;
      this.dialogVisible = true;
      this.$confirm("", "操作确认", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        // type: "none",
        message: h("p", null, [
          h("span", { style: " font-size:18px；" }, "你即将进行"),
          h("b", { style: "color: red; font-size:18px" }, "合闸"),
          h("span", { style: " font-size:18px" }, "操作 !"),
        ]),
      })
        .then(() => {
          if (this.dialogVisible) {
            this.onChan = "clo";
            this.onage = "po";
            this.statul = "合闸";
            this.st = "ored";
          }
          this.$message({
            type: "success",
            message: "合闸操作成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    initEcharts() {
      let echarts = require("echarts");
      this.myChart = echarts.init(this.$refs.echartsDom);
      this.myChart.setOption({
        color: ["#5B8FF9", "#5AD8A6", "#5D7092"],
        legend: {
          itemWidth: 16,
          itemHeight: 16,
          x: "center",
          type: "plain",
          icon: "square", //正方形图例
          data: ["A相", "B相", "C相"],
          left: "63%", // 图例的位置
          textStyle: {
            color: "#999999",
          },
        },
        title: {
          text: "电流曲线",
        },

        dataset: {
          source: [
            ["product", "2点", "4点", "6点", "8点", "10点", "12点"],
            ["A相", 56.5, 82.1, 88.7, 70.1, 53.4, 85.1],
            ["B相", 51.1, 51.4, 55.1, 53.3, 73.8, 68.7],
            ["C相", 40.1, 62.2, 69.5, 36.4, 45.2, 32.5],
          ],
        },
        grid: {
          top: "26%",
          right: "2%",
          bottom: "10%",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            animation: false,
          },

          textStyle: {
            //图例文字的样式
            color: "bolck", //文字颜色
            fontSize: 12, //文字大小
          },
        },
        xAxis: { type: "category" },
        yAxis: {
          type: "value",
        },
        series: [
          {
            type: "line",
            smooth: true,
            seriesLayoutBy: "row",
          },
          {
            type: "line",
            smooth: true,
            seriesLayoutBy: "row",
          },
          {
            type: "line",
            smooth: true,
            seriesLayoutBy: "row",
          },
        ],
      });
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
    },

    initEcharts1() {
      let echarts1 = require("echarts");
      this.myChart1 = echarts1.init(this.$refs.echartsDom1);

      this.myChart1.setOption({
        color: ["#5B8FF9", "#5AD8A6", "#5D7092"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            animation: false,
          },
          // formatter: function (params) {
          //   return (
          //     "A:" +
          //     params.data.totalSales +
          //     "</br>" +
          //     "B:" +
          //     params.data.refunedSales +
          //     "</br>" +
          //     "C:" +
          //     params.data.value
          //   );
          // },
          textStyle: {
            //图例文字的样式
            color: "bolck", //文字颜色
            fontSize: 12, //文字大小
          },
        },
        legend: {
          itemWidth: 16,
          itemHeight: 16,
          x: "center",
          type: "plain",
          icon: "square", //正方形图例
          data: ["A相", "B相", "C相"],
          left: "63%", // 图例的位置
          textStyle: {
            color: "#999999",
          },
        },
        title: {
          text: "电压曲线",
        },

        dataset: {
          source: [
            ["product", "2点", "4点", "6点", "8点", "10点", "12点"],
            ["A相", 56.5, 82.1, 88.7, 70.1, 53.4, 85.1],
            ["B相", 51.1, 51.4, 55.1, 53.3, 73.8, 68.7],
            ["C相", 40.1, 62.2, 69.5, 36.4, 45.2, 32.5],
          ],
        },
        grid: {
          top: "26%",
          right: "2%",
          bottom: "10%",
        },
        xAxis: { type: "category" },
        yAxis: {
          type: "value",
        },
        series: [
          {
            type: "line",
            smooth: true,
            seriesLayoutBy: "row",
          },
          {
            type: "line",
            smooth: true,
            seriesLayoutBy: "row",
          },
          {
            type: "line",
            smooth: true,
            seriesLayoutBy: "row",
          },
        ],
      });
      window.addEventListener("resize", () => {
        this.myChart1.resize();
      });
    },
    initEcharts2() {
      let echarts2 = require("echarts");
      this.myChart2 = echarts2.init(this.$refs.echartsDom2);

      this.myChart2.setOption({
        title: {
          text: "回路负载率",
        },

        tooltip: {
          trigger: "item",
          formatter: `{a} <br/>{b}: {c} ({d}%)`,
          textStyle: {
            //图例文字的样式
            color: "bolck", //文字颜色
            fontSize: 12, //文字大小
          },
        },
        graphic: [
          {
            type: "text",
            top: "44%",
            left: "11%",
            style: {
              text: "10000.00", //中间总金额
              fill: "#333333",
              fontSize: 20,
              fontWeight: "normal",
            },
          },
          {
            type: "text",
            top: "57%",
            left: "17%",
            style: {
              text: "实发工资",
              fill: "#A6A8B6",
              fontSize: 13,
              fontWeight: "normal",
            },
          },
        ],
        //圆环的颜色
        color: ["#E8684A", "#6DC8EC"],

        series: [
          {
            name: "工资占比图", //代表a的值，系列名称
            type: "pie",
            data: [
              { value: 1048, name: "总负载率" },
              { value: 735, name: "回路负载率" },
            ],
            center: ["24%", "50%"], //饼图的中心（圆心）坐标，数组的第一项是横坐标，第二项是纵坐标。
            radius: ["45%", "60%"], //饼图的半径，数组的第一项是内半径，第二项是外半径。[ default: [0, '75%'] ]
            avoidLabelOverlap: false, //是否禁用动画效果

            label: {
              show: false, //是否显示标签

              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
            labelLine: {
              position: "inner", //隐藏引导线
              show: false, //隐藏标识文字
            },

            // 系列中的数据内容数组。
          },
        ],
      });
      window.addEventListener("resize", () => {
        this.myChart2.resize();
      });
    },
    //改变表头
    //改变table颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        console.log(row, column, columnIndex);
        return "background-color:rgba(0, 0, 0,0.06);color: #000000;font-weight: 700;";
      }
    },
    //表格颜色
    //改变table颜色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 != 0) {
        //=>这里可以改成 rowIndex%2=== 1，后面直接else即可达到隔行变色效果。
        return "warning-row";
      }
      return "";
    },
  },
};
</script>
<style lang="less" scoped>
.about {
  display: flex;
  // padding-left: 23px;
  .infinite-list {
    height: 900px;
  }
  // .infinite-list::-webkit-scrollbar {
  //   display: none;
  // }
  .Pngfute {
    width: 330px;
    height: 602px;
    background-image: url(../assets/img/bg.png);
    // border-bottom: 1px solid black;
    padding: 25px 0;
    background-size: 100% 100%;
    .oimg {
      width: 280px;
      height: 552px;
      background-color: #fff;
      margin: auto;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .state {
    margin-top: -2px;
    background-image: url(../assets/img/倒影@2x.png);
    background-size: 100% 100%;
    width: 330px;
    height: 53px;
    margin-bottom: 6px;
    .ored {
      color: #fd4238;
    }
    .ogreen {
      color: #01ab65;
      // background-color:green;
    }
    .setState {
      width: 230px;
      height: 51px;
      background-image: url(../assets/img/aftstate.png);
      background-size: 230px 57px;
      margin: auto;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .bar {
    width: 330px;
    display: flex;
    justify-content: center;
    // align-items: center;
    padding: 0 46px;
    text-align: center;

    .popo {
      width: 80px;
      height: 80px;
    }
    .clo {
      border-radius: 50%;
      width: 80px;
      height: 80px;
      background-image: url(../assets/img/botton1.png);
      cursor: pointer;
      background-size: 80px 80px;
      font-size: 24px;
      font-weight: 500;
      color: #ffffff;
      line-height: 80px;
    }
    .po {
      border-radius: 50%;
      width: 80px;
      height: 80px;
      background-image: url(../assets/img/botton2.png);

      background-size: 80px 80px;
      font-size: 24px;
      font-weight: 500;
      color: #ffffff;
      line-height: 80px;
      //  cursor: no-drop;
      pointer-events: none;
    }
  }

  .middle {
    margin-left: 15px;
    .table {
      width: 586px;
      height: 540px;
      margin-bottom: 124px;
    }
    .trigger {
      width: 195px;
      height: 81px;
      background-image: url(../assets/img/btnstuts.png);
      background-size: 195px 81px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      padding: 0px 18px 10px 0;
      .jadk {
        text-align: center;
        line-height: 50px;
        border-bottom: 1px solid rgb(209, 206, 206);
      }
      .jadk:hover {
        box-shadow: 20px 10px 40px gray;
      }
      .el-icon-sort {
        font-size: 22px;
      }
      .swtrGet {
        font-size: 24px;
        font-weight: 500;
        color: #333333;
        margin-left: 8px;
        cursor: pointer;
      }
    }
  }

  .dexter {
    margin-left: 30px;
    .oia {
      margin-bottom: 31px;
      .myCharts {
        width: 424px;
        height: 224px;
        margin-bottom: 31px;
      }
    }
    .oib {
      margin-bottom: 41px;
      .myCharts1 {
        width: 424px;
        height: 224px;
      }
    }
    .opl {
      position: relative;
      .myCharts2 {
        width: 336px;
        height: 214px;
      }

      .pink {
        width: 10px;
        height: 10px;
        background-color: #e8684a;
      }
      .gruen {
        width: 10px;
        height: 10px;
        background-color: #6dc8ec;
      }
      .PngUl {
        position: absolute;
        top: 40px;
        left: 160px;
      }
      .pngLi {
        width: 100px;
        display: flex;
        justify-content: space-between;
        // justify-content: center;
        align-items: center;
      }
    }
  }
  .upward {
    position: absolute;
    width: 100%;
    height: 50px;
    top: 0;
    background-color: #ffffff;
    text-align: center;
    font-size: 28px;
    line-height: 50px;
    border-bottom: 1px solid rgba(128, 128, 128, 0.4);
    z-index: 9999;
  }
  .downward {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    background-color: #fff;
    text-align: center;
    line-height: 50px;
    font-size: 28px;
    border-top: 1px solid rgba(128, 128, 128, 0.4);
    z-index: 9999;
  }
  .vue-drag-scroll-out-wrapper::-webkit-scrollbar {
    display: none;
  }
  .vue-drag-scroll-wrapper {
    margin-top: 50px;
  }
  .vue-drag-scroll-out-wrapper {
    width: 100%;
    overflow-x: hidden;
    /* width: 100%; */
    height: 100%;
    cursor: grab;
    position: absolute;
    top: 0;
    left: 0;
  }
  .nonum {
    text-align: center;
    margin-top: 20px;
    color: rgb(189, 189, 189, 0.5);
  }
  .mar {
    margin: auto;
    .tors {
      width: 400px;
      height: 400px;
      margin: auto;
      // background-color: red;
      text-align: center;
      img {
        margin-top: 88px;
        margin-right: 80px;
        margin-left: 80px;
      }
      .oP {
        font-size: 18px;
        font-weight: 400;
        color: #999999;
        margin-top: 24px;
      }
    }
  }
  .fors {
    display: flex;
    // text-align: center;
  }
}
.antfos {
  color: #0d94ff;
}
</style>